import _ from "lodash";
import { useContext } from "react";
import { ActivePosition } from "src/types/products";

import Context from "../../../../../context";
import ResultContext from "../../context";

export type Position = {
	type: string;
	value: number;
	currency: string;
	weight: number;
	children: ActivePosition[];
};

export default function useGetPositionRows() {
	const { state } = useContext(Context);
	const resultContext = useContext(ResultContext);

	const isByPortfolio = resultContext.state.showType === "PORTFOLIO";

	if (!state.demoData) return { demoRows: [] };

	const { activePositions } = state.demoData;

	const IDs = _.uniq(_.map(activePositions, "assetType"));

	const demoRows = IDs.map((id) => {
		const filtered = activePositions.filter((i) => i.assetType === id);
		const totalAmount = filtered.reduce((acc, position) => acc + position.amount, 0);
		const total = activePositions.reduce((acc, position) => acc + position.amount, 0);
		return {
			type: id,
			currency: activePositions[0].currency,
			value: totalAmount,
			weight: (totalAmount / total) * 100,
			children: filtered.map((i) => ({ ...i, weight: (i.amount / totalAmount) * 100 }))
		};
	});

	return {
		demoRows
	};
}
